module.exports = __webpack_public_path__ + "static/media/Piazza gold.6500feff.jpg";